module.exports = __webpack_public_path__ + "static/media/small_painting.2107c332.jpg";